import { render, staticRenderFns } from "./physical-device-wizard.vue?vue&type=template&id=3fa0b10b&"
import script from "./physical-device-wizard.vue?vue&type=script&lang=js&"
export * from "./physical-device-wizard.vue?vue&type=script&lang=js&"
import style0 from "./physical-device-wizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports